import styled from 'styled-components'

const LeftPanel = styled.div`
  width: 35%;
  max-width: 340px;
  margin-right: 2%;
`

export default LeftPanel
